import React, { forwardRef } from 'react';

interface textAreaInteractions {
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
}

interface textAreaOptions {
  disabled?: boolean;
  placeholder?: string;
  error?: string;
}

interface identifiers {
  id: string;
}

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  identifiers: identifiers;
  interactions?: textAreaInteractions;
  textAreaOptions?: textAreaOptions;
  className?: string;
}

const TextAreaInput = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    { identifiers, interactions, textAreaOptions, className = '', ...props },
    ref,
  ) => {
    return (
      <div className="relative w-full" id={identifiers?.id}>
        <textarea
          id={`textarea-${identifiers.id}`}
          onChange={interactions?.onChange}
          onBlur={interactions?.onBlur}
          onFocus={interactions?.onFocus}
          disabled={textAreaOptions?.disabled}
          placeholder={textAreaOptions?.placeholder}
          ref={ref}
          className={`
            outline-none w-full p-[1.2rem] border border-[#DDDDDD] rounded-[0.8rem] text-[1.2rem] leading-[1.6rem]
            ${textAreaOptions?.error && 'border-[#DB230A] focus:[#DB230A]'}
            ${className}
          `}
          {...props}
        />
        {textAreaOptions?.error && (
          <div
            id={`text-area-error-${identifiers.id}`}
            className="mt-3 text-left text-lg font-normal text-[#DB230A]"
          >
            {textAreaOptions.error}
          </div>
        )}
      </div>
    );
  },
);

export default TextAreaInput;
